import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { MuiList, MuiMenuItem } from './MuiList.styles';
import { MuiAlert } from './muiAlert.styles';
import { MuiAppBar } from './muiAppBar.styles';
import { MuiButton, MuiButtonBase } from './muiButton.styles';
import { MuiChip } from './muiChip.styles';
import {
  MuiDialog,
  MuiDialogContent,
  MuiDialogTitle,
} from './muiDialog.styles';
import { MuiDivider } from './muiDivider.styles';
import { MuiDrawer } from './muiDrawer.styles';
import { MuiFormHelperText } from './muiFormHelperText.styles';
import { MuiIconButton } from './muiIconButton.styles';
import {
  MuiAutocomplete,
  MuiCheckbox,
  MuiFilledInput,
  MuiFormLabel,
  MuiOutlinedInput,
  MuiTextField,
} from './muiInputField.styles';
import { MuiLink } from './muiLink.styles';
import { MuiPaper } from './muiPaper.styles';
import { MuiSelect } from './muiSelect.styles';
import { MuiSlider } from './muiSlider.styles';
import { MuiSnackbar } from './muiSnackBar.styles';
import { MuiSvgIcon } from './muiSvgIcon.styles';
import { MuiSwitch } from './muiSwitch.styles';
import { MuiTab, MuiTabs } from './muiTab.styles';
import {
  MuiTableCell,
  MuiTableContainer,
  MuiTableRow,
} from './muiTable.styles';
import { MuiTablePagination } from './muiTablePagination.styles';
import { MuiToolbar } from './muiToolbar.styles';
import { MuiTooltip } from './muiTooltip.styles';
import { MuiTypography } from './muiTypography.styles';

const getMuiOverrides = ({
  defaultTheme,
}: {
  defaultTheme: Theme;
}): Partial<Components> => ({
  ...MuiSnackbar(defaultTheme),
  ...MuiAlert(defaultTheme),
  ...MuiAppBar(defaultTheme),
  ...MuiSvgIcon(defaultTheme),
  ...MuiPaper(defaultTheme),
  ...MuiTab(defaultTheme),
  ...MuiTabs(defaultTheme),
  ...MuiDrawer(defaultTheme),
  ...MuiIconButton(),
  ...MuiButton(defaultTheme),
  ...MuiButtonBase(),
  ...MuiSelect(),
  ...MuiSlider(defaultTheme),
  ...MuiSwitch(defaultTheme),
  ...MuiTypography(defaultTheme),
  ...MuiTableCell(defaultTheme),
  ...MuiTableContainer(),
  ...MuiTableRow(),
  ...MuiDialog(defaultTheme),
  ...MuiDialogTitle(defaultTheme),
  ...MuiDialogContent(defaultTheme),
  ...MuiDivider(),
  ...MuiTextField(),
  ...MuiOutlinedInput(defaultTheme),
  ...MuiFilledInput(defaultTheme),
  ...MuiFormHelperText(),
  ...MuiFormLabel(defaultTheme),
  ...MuiCheckbox(defaultTheme),
  ...MuiAutocomplete(defaultTheme),
  ...MuiChip(defaultTheme),
  ...MuiTooltip(defaultTheme),
  ...MuiTablePagination(defaultTheme),
  ...MuiList(),
  ...MuiMenuItem(defaultTheme),
  ...MuiLink(),
  ...MuiToolbar(defaultTheme),
});
export default getMuiOverrides;
